import { render } from "./ArabicText.vue?vue&type=template&id=b14b58fa&ts=true"
import script from "./ArabicText.vue?vue&type=script&lang=ts"
export * from "./ArabicText.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__